import { useState } from 'react'
import { budgetAPI } from '../services/api'
import { getMonthYear } from '../utils/helpers'

export default function BudgetSetting({ currentBudget, onClose, onSuccess }) {
  const [amount, setAmount] = useState(
    currentBudget?.amount 
      ? String(currentBudget.amount).replace(/\B(?=(\d{3})+(?!\d))/g, '.') 
      : ''
  )
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const formatAmount = (value) => {
    const numbers = value.replace(/\D/g, '')
    return numbers.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const numericAmount = parseInt(amount.replace(/\D/g, ''))
    if (!numericAmount || numericAmount <= 0) {
      setError('Masukkan jumlah budget yang valid')
      return
    }

    setLoading(true)
    try {
      await budgetAPI.set({
        month: getMonthYear(),
        amount: numericAmount,
      })
      onSuccess()
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl p-6 w-full max-w-sm">
        <div className="flex justify-between items-center mb-4">
          <h2 className="font-bold text-lg">Set Budget Bulan Ini</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">✕</button>
        </div>

        {error && (
          <div className="bg-red-50 text-red-600 p-3 rounded-lg text-sm mb-4">{error}</div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="label">Jumlah Budget (Rp)</label>
            <div className="relative">
              <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 font-medium">Rp</span>
              <input
                type="text"
                inputMode="numeric"
                placeholder="0"
                value={amount}
                onChange={(e) => setAmount(formatAmount(e.target.value))}
                className="input-field pl-10"
                autoFocus
              />
            </div>
          </div>

          <div className="flex gap-3">
            <button type="button" onClick={onClose} className="btn-secondary flex-1">
              Batal
            </button>
            <button
              type="submit"
              disabled={loading || !amount}
              className="btn-primary flex-1 disabled:opacity-50"
            >
              {loading ? 'Menyimpan...' : 'Simpan'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
